import {Component, Input, OnInit, Output} from '@angular/core';
import Relator from '../../helpers/relator/relator';
import {ApiVirtualizationLayerService} from '../../services/api-virtualization-layer/api-virtualization-layer.service';
import { ToasterService } from 'angular2-toaster';
import { ToastNotificationService } from '../../services/toast-notification/toast-notification.service';

@Component({
  selector:    'ngx-mass-messenger-message-composer-form',
  templateUrl: './mass-messenger-message-composer-form.component.html',
  styleUrls:   ['./mass-messenger-message-composer-form.component.scss']
})
export class MassMessengerMessageComposerFormComponent implements OnInit {
  @Input() messageBody = '';
  @Input() cloudinaryResults = [];

  ckConfig = {
    autoParagraph: false,
    toolbar:       [
      ['Bold', 'Italic', 'Underline', 'StrikeThrough', '-', 'Undo', 'Redo', '-', 'Cut', 'Copy', 'Paste', 'Find', 'Replace', '-', 'Outdent', 'Indent', '-'],
      '/',
      ['NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
      ['Image', 'Table', '-', 'Link', 'Flash', 'Smiley', 'TextColor', 'BGColor'],
    ],
    removePlugins: 'elementspath',
  }

  constructor(private apiv: ApiVirtualizationLayerService, private toaster: ToastNotificationService) {
  }

  ngOnInit() {
  }

  private cloudinaryWidget = null;

  cloudinaryUpload() {
    this.cloudinaryWidget = window['cloudinary'].createUploadWidget({
        cloudName: 'wedaycare',
        uploadPreset: 'vsv6b2hu'}, (error, result) => {
        console.info(result.event);
        if (!error && result && result.event === 'success') {
          console.info('Done! Here is the image info: ', result.info);
          this.cloudinaryResults.push(result.info);
          this.apiv.cloudinaryResults = this.cloudinaryResults;
        }

        if (result.event === 'queues-end') {
          alert('Alle bestanden zijn geüpload.');
        }

        /*if (result.event === 'close') {

        }*/
      }
    )

    this.cloudinaryWidget.open();
  }

  detectCloudinaryType(cloudinaryResult) {
    switch (cloudinaryResult.format.toLowerCase()) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'heif':
        return 'image';
        // message += '<img src="' + cloudinaryResult.url + '" width="100%"/>';
      case 'mov':
      case 'mp4':
      case 'mpg':
        return 'video';
        // message += '<video controls width="100%">\n' +
        //            '  <source src="' + cloudinaryResult.url + '">' +
        //            '</video>';
    }
  }

  deleteCloudinaryResult(index) {
    Relator.removeAt(index, this.cloudinaryResults);
    this.cloudinaryResults = [...this.cloudinaryResults];
    this.apiv.cloudinaryResults = this.cloudinaryResults;
  }

  changeBody(input) {
    this.apiv.messageBody = input;
  }
}
